// Static interface labels. French source text is the translation key.
export const uiPtBR: Record<string, string> = {
  "{count} cartes posées.": "{count} cartas descartadas.",
  "Voir les cartes en grand": "Ver cartas em tamanho maior",
  "Voir la carte {number} en grand": "Ver a carta {number} em tamanho maior",
  "Les cartes": "As cartas",
  "Carte précédente": "Carta anterior",
  "Carte suivante": "Próxima carta",
  "Carte {current} sur {total}": "Carta {current} de {total}",
  "Glisse pour changer de carte": "Deslize para trocar de carta",
  "{ready} / {total} illustrations prêtes. Les autres symboles sont provisoires.": "{ready} / {total} ilustrações prontas. Os outros símbolos são provisórios.",
  "Virou! Accueil": "Virou! Início",
  "Voir mon niveau et mes badges": "Ver meu nível e minhas conquistas",
  NIVEAU: "NÍVEL",
  "0 XP": "0 XP",
  "Activer le son": "Ativar o som",
  "RECIFE · PERNAMBUCO": "RECIFE · PERNAMBUCO",
  RECIFE: "RECIFE",
  "TROUVE.": "ACHE.",
  "EMPILE.": "EMPILHE.",
  SOLO: "SOLO",
  "10 cartes": "10 cartas",
  "CLIQUE. EMPILE.": "CLIQUE. EMPILHE.",
  "Un symbole commun. Zéro temps à perdre.":
    "Um símbolo em comum. Sem tempo a perder.",
  "LE RYTHME DU JEU": "NO RITMO DO JOGO",
  "LA PIOCHE": "O MONTE",
  "TA FUTURE PILE": "SUA FUTURA PILHA",
  "1 SYMBOLE": "1 SÍMBOLO",
  "EN COMMUN.": "EM COMUM.",
  "LA TOUR": "A TORRE",
  "2–8 JOUEURS": "2–8 JOGADORES",
  "FAIS MONTER": "AUMENTE",
  "PRESSION.": "PRESSÃO.",
  "CRÉER UNE PARTIE": "CRIAR PARTIDA",
  "J’AI UN CODE": "TENHO UM CÓDIGO",
  "ÉCHAUFFE TES RÉFLEXES": "AQUEÇA SEUS REFLEXOS",
  "Solo · 10 cartes · À toi de jouer": "Solo · 10 cartas · Sua vez de jogar",
  "Connexion…": "Conectando…",
  "SANS COMPTE": "SEM CONTA",
  "57 CARTES. 8 SYMBOLES. UN SEUL MATCH.":
    "57 CARTAS. 8 SÍMBOLOS. UMA COMBINAÇÃO.",
  "COMMENT ÇA JOUE ?": "COMO JOGAR?",
  "MODE HORS ÉCRAN": "MODO FORA DA TELA",
  "TA PILE.": "SUA PILHA.",
  "EN VRAI.": "NA VIDA REAL.",
  "Imprime. Découpe. Défie ta bande.": "Imprima. Recorte. Desafie a galera.",
  "TON PAQUET": "SEU BARALHO",
  "Classique · 57 cartes / 8 symboles": "Clássico · 57 cartas / 8 símbolos",
  "Découverte · 31 cartes / 6 symboles": "Descoberta · 31 cartas / 6 símbolos",
  "Mini · 13 cartes / 4 symboles": "Mini · 13 cartas / 4 símbolos",
  "TAILLE DES CARTES": "TAMANHO DAS CARTAS",
  "Taille classique · Ø 85 mm": "Tamanho clássico · Ø 85 mm",
  "Agrandies pour la page": "Ampliadas para a página",
  "CARTES PAR FEUILLE A4": "CARTAS POR FOLHA A4",
  "100 % / taille réelle.": "100% / tamanho real.",
  "Vérifie le repère de 50 mm avant de découper.":
    "Confira a marca de 50 mm antes de recortar.",
  "RÉCUPÉRER MON JEU": "BAIXAR MEU JOGO",
  "Le paquet entier. Prêt à jouer.": "O baralho completo. Pronto para jogar.",
  "APERÇU A4": "PRÉVIA A4",
  "Page précédente": "Página anterior",
  "Page suivante": "Próxima página",
  "✳ Les 57 illustrations arrivent bientôt. En attendant : symboles provisoires, vrais défis.":
    "✳ As 57 ilustrações chegam em breve. Por enquanto: símbolos provisórios, desafios de verdade.",
  "LE TUTO EXPRESS": "TUTORIAL RÁPIDO",
  "UN MATCH.": "UMA COMBINAÇÃO.",
  "UN POINT.": "UM PONTO.",
  "Tout le monde joue en même temps.": "Todo mundo joga ao mesmo tempo.",
  "RAMEUTE TA TEAM": "CHAME A GALERA",
  "Crée une partie et partage son code. À partir de 2 joueurs, l’hôte lance la manche.":
    "Crie uma partida e compartilhe o código. A partir de 2 jogadores, o anfitrião inicia a rodada.",
  "TROUVE LE MATCH": "ACHE A COMBINAÇÃO",
  "Entre ta carte et celle du centre : un seul symbole commun. Touche-le sur l’une ou l’autre carte.":
    "Entre sua carta e a do centro há um único símbolo em comum. Toque nele em qualquer uma das cartas.",
  "FAIS GROSSIR TA PILE": "AUMENTE SUA PILHA",
  "Le premier bon clic gagne la carte. Elle remplace la sienne. Plus de cartes au centre ? La plus grande pile gagne.":
    "O primeiro clique certo ganha a carta, que substitui a sua. Acabaram as cartas no centro? A maior pilha vence.",
  "Un raté ne retire aucun point.": "Um erro não tira pontos.",
  "Ta série, elle, repart de zéro !": "Mas sua sequência volta a zero!",
  "OK, JE M’ENTRAÎNE": "OK, VOU PRATICAR",
  "Navigation principale": "Navegação principal",
  Jouer: "Jogar",
  JOUER: "JOGAR",
  Imprimer: "Imprimir",
  IMPRIMER: "IMPRIMIR",
  "Les règles": "As regras",
  "LES RÈGLES": "AS REGRAS",
  Fermer: "Fechar",
  "C’EST TOI QUI INVITES": "VOCÊ É QUEM CONVIDA",
  OUVRE: "ABRA",
  "LA PARTIE.": "A PARTIDA.",
  "TON PSEUDO": "SEU APELIDO",
  "Un autre pseudo": "Gerar outro apelido",
  "PALMARÈS": "PLACAR",
  "Comment jouer": "Como jogar",
  "Compare les cartes": "Compare as cartas",
  "Touche le symbole commun": "Toque no símbolo igual",
  "La carte change": "A carta muda",
  "TA CARTE": "SUA CARTA",
  "AU CENTRE": "NO CENTRO",
  "À toi d’essayer": "Tente agora",
  "Rejouer la démo": "Repetir demonstração",
  "Original · Ø 85 mm": "Original · Ø 85 mm",
  "Télécharger le PDF": "Baixar PDF",
  "SYMBOLES": "ACERTOS",
  "SÉRIE MAX": "SEQUÊNCIA",
  "VICTOIRES": "VITÓRIAS",
  "BADGES": "CONQUISTAS",
  "Capitaine Virou": "Capitão Virou",
  "Taille du paquet": "Tamanho do baralho",
  "Classique · 57 cartes": "Clássico · 57 cartas",
  "Découverte · 31 cartes": "Descoberta · 31 cartas",
  "Mini · 13 cartes": "Mini · 13 cartas",
  "C’EST PARTI": "VAMOS LÁ",
  "2 à 8 joueurs · Pas d’inscription": "2 a 8 jogadores · Sem cadastro",
  "TA TEAM T’ATTEND": "A GALERA ESTÁ ESPERANDO",
  ENTRE: "ENTRE",
  "DANS LE JEU.": "NO JOGO.",
  "CODE DE LA PARTIE": "CÓDIGO DA PARTIDA",
  ABCDEF: "ABCDEF",
  "REJOINDRE LA TEAM": "ENTRAR NA PARTIDA",
  "TU NOUS QUITTES ?": "JÁ VAI EMBORA?",
  DERNIÈRE: "ÚLTIMA",
  "CARTE ?": "CARTA?",
  "Tu vas quitter cette partie.": "Você vai sair desta partida.",
  "JE RESTE": "VOU FICAR",
  QUITTER: "SAIR",
  "Progression enregistrée sur cet appareil.":
    "Progresso salvo neste dispositivo.",
  Langue: "Idioma",
  LA: "A",
};

export default uiPtBR;
